/* ─── Root ─── */

.root {
  position: fixed;
  top: 0;
  bottom: 0;
  inset-inline-start: 0;
  width: 80px;
  z-index: var(--z-sticky);
  background: var(--md-surface);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--space-3) 0;
  gap: var(--space-2);
  font-family: var(--font-sans);
}

/* ─── FAB slot ─── */

.fab {
  margin-bottom: var(--space-4);
}

/* ─── List ─── */

.list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
}

/* ─── Item ─── */

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-1);
  width: 56px;
  text-decoration: none;
  color: var(--md-on-surface-variant);
  border: none;
  background: transparent;
  cursor: pointer;
  padding: var(--space-1) 0;
  position: relative;
  font-family: var(--font-sans);
  border-radius: var(--shape-full);
}

.item[data-active] {
  color: var(--md-on-secondary-container);
}

/* ─── Icon ─── */

.itemIcon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

/* Active indicator pill behind icon */
.itemIcon::before {
  content: "";
  position: absolute;
  width: 64px;
  height: 32px;
  border-radius: var(--shape-full);
  background: var(--md-secondary-container);
  z-index: -1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: transform var(--motion-duration-short3)
      var(--motion-easing-standard),
    opacity var(--motion-duration-short3) var(--motion-easing-standard);
}

.item:not([data-active]) .itemIcon::before {
  opacity: 0;
  transform: translate(-50%, -50%) scaleX(0);
}

/* ─── Label ─── */

.itemLabel {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
}
